'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../node_modules/reflect-metadata/Reflect.js');
var enums = require('../types/cms/enums.js');
var classes = require('../types/cms/classes.js');
var cmsMetadataUtilities = require('../utils/cms/cmsMetadataUtilities.js');

/**
 * Decorator used to inform CMS how to present a given component.
 */
const CMSObject = (key, name, options) => {
    return (classRef) => {
        cmsMetadataUtilities.setClassMetadataByKey(key, classRef);
        Reflect.defineMetadata(enums.MetadataTypes.Object, new classes.ObjectMetaData(key, name, options), classRef.prototype);
    };
};
/**
 * Decorator used to inform CMS how to define content for a given component.
 */
const CMSField = (label, type, options) => {
    return (classRef, field) => {
        var _a;
        const fieldMetadata = new classes.FieldMetaData(field, label, type, options);
        if (options === null || options === void 0 ? void 0 : options.childFieldsType) {
            fieldMetadata.childFields = (_a = cmsMetadataUtilities.getClassMetadata(options.childFieldsType)) === null || _a === void 0 ? void 0 : _a.fields;
        }
        Reflect.defineMetadata(`${enums.MetadataTypes.Field}:${field}`, fieldMetadata, classRef);
    };
};

exports.CMSField = CMSField;
exports.CMSObject = CMSObject;
//# sourceMappingURL=cms.js.map
